import { render, staticRenderFns } from "./screenDistriDetails.vue?vue&type=template&id=fa96a2b2&scoped=true"
import script from "./screenDistriDetails.vue?vue&type=script&lang=js"
export * from "./screenDistriDetails.vue?vue&type=script&lang=js"
import style0 from "./screenDistriDetails.vue?vue&type=style&index=0&id=fa96a2b2&prod&lang=scss&scoped=true"
import style1 from "./screenDistriDetails.vue?vue&type=style&index=1&id=fa96a2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96a2b2",
  null
  
)

export default component.exports